import { render, staticRenderFns } from "./mIndexList.vue?vue&type=template&id=63790e40&"
import script from "./mIndexList.vue?vue&type=script&lang=js&"
export * from "./mIndexList.vue?vue&type=script&lang=js&"
import style0 from "./mIndexList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports